import { render, staticRenderFns } from "./SendSMSQuickText.vue?vue&type=template&id=f2bab7e2&"
import script from "./SendSMSQuickText.vue?vue&type=script&lang=js&"
export * from "./SendSMSQuickText.vue?vue&type=script&lang=js&"
import style0 from "./SendSMSQuickText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports